(function () {
    'use strict';

    angular.module("imApp").factory("ediDestinationService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 988,
                    parameters: parms || {}
                });
            },
            listExternalTypes: function (parms) {
                return $ihttp.post({
                    method: 990,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 989,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
